var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v("Create Team Member Invoices"),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "form-wrapper",
          { staticClass: "form-wrapper", attrs: { validator: _vm.$v } },
          [
            _c(
              "div",
              { staticClass: "form-container" },
              [
                _vm.canViewTeamRegion
                  ? _c("team-region-member-filter-options", {
                      attrs: {
                        "team-region-id": _vm.teamRegionId,
                        "strict-team-region-filter": true,
                        clearable: false,
                      },
                      on: { changed: _vm.handleTeamRegionMemberChanged },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "skillfield-container tag-padding" },
                  [
                    _c("vue-select", {
                      attrs: {
                        options: _vm.tags,
                        reduce: function (t) {
                          return t.tagId
                        },
                        placeholder: "Set tag",
                        label: "name",
                        "append-to-body": "",
                      },
                      model: {
                        value: _vm.selectedTagId,
                        callback: function ($$v) {
                          _vm.selectedTagId = $$v
                        },
                        expression: "selectedTagId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "hide-clear-button" },
                  [
                    _c(
                      "md-datepicker",
                      {
                        attrs: { "md-immediately": "", "md-debounce": 10 },
                        model: {
                          value: _vm.startDate,
                          callback: function ($$v) {
                            _vm.startDate = $$v
                          },
                          expression: "startDate",
                        },
                      },
                      [_c("label", [_vm._v("Start Date")])]
                    ),
                    _vm.startDate == null
                      ? _c("span", { staticClass: "error" }, [
                          _vm._v(
                            "\n                        Start date is required.\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "hide-clear-button" },
                  [
                    _c(
                      "md-datepicker",
                      {
                        attrs: { "md-immediately": "", "md-debounce": 10 },
                        model: {
                          value: _vm.endDate,
                          callback: function ($$v) {
                            _vm.endDate = $$v
                          },
                          expression: "endDate",
                        },
                      },
                      [_c("label", [_vm._v("End Date")])]
                    ),
                    _vm.endDate == null
                      ? _c("span", { staticClass: "error" }, [
                          _vm._v(
                            "\n                        End date is required.\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "hide-clear-button" },
                  [
                    _c(
                      "md-datepicker",
                      {
                        attrs: { "md-immediately": "", "md-debounce": 10 },
                        model: {
                          value: _vm.dueDate,
                          callback: function ($$v) {
                            _vm.dueDate = $$v
                          },
                          expression: "dueDate",
                        },
                      },
                      [_c("label", [_vm._v("Due Date")])]
                    ),
                    _vm.dueDate == null
                      ? _c("span", { staticClass: "error" }, [
                          _vm._v(
                            "\n                        Due date is required.\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "hide-clear-button" },
                  [
                    _c(
                      "md-datepicker",
                      {
                        attrs: { "md-immediately": "", "md-debounce": 10 },
                        model: {
                          value: _vm.invoiceDate,
                          callback: function ($$v) {
                            _vm.invoiceDate = $$v
                          },
                          expression: "invoiceDate",
                        },
                      },
                      [_c("label", [_vm._v("Invoice Date")])]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "feature",
                        rawName: "v-feature",
                        value: [_vm.featureName.DraftInvoices],
                        expression: "[featureName.DraftInvoices]",
                      },
                    ],
                  },
                  [
                    _c(
                      "md-checkbox",
                      {
                        staticClass: "custom-switch-blue",
                        model: {
                          value: _vm.isDraft,
                          callback: function ($$v) {
                            _vm.isDraft = $$v
                          },
                          expression: "isDraft",
                        },
                      },
                      [_vm._v("Draft Invoices")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary",
            on: { click: _vm.createInvoices },
          },
          [_vm._v("Create Invoices")]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("Cancel")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }